import { render, staticRenderFns } from "./ItemListVariazioneArrayItemsOrdineMTM.vue?vue&type=template&id=8718f764"
import script from "./ItemListVariazioneArrayItemsOrdineMTM.vue?vue&type=script&lang=ts"
export * from "./ItemListVariazioneArrayItemsOrdineMTM.vue?vue&type=script&lang=ts"
import style0 from "./ItemListVariazioneArrayItemsOrdineMTM.vue?vue&type=style&index=0&id=8718f764&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8718f764')) {
      api.createRecord('8718f764', component.options)
    } else {
      api.reload('8718f764', component.options)
    }
    module.hot.accept("./ItemListVariazioneArrayItemsOrdineMTM.vue?vue&type=template&id=8718f764", function () {
      api.rerender('8718f764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListVariazioneArrayItemsOrdineMTM.vue"
export default component.exports